import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screen-sign-in',
  templateUrl: './screen-sign-in.component.html',
  styleUrls: ['./screen-sign-in.component.sass']
})
export class ScreenSignInComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
